import type { Urteil } from '../data/kaufplan.types'
import { URTEIL_STYLE } from './urteil'

export default function UrteilBadge({ u }: { u: Urteil }) {
  const s = URTEIL_STYLE[u]
  return (
    <span className="badge font-mono text-[10px] font-bold tracking-wider whitespace-nowrap"
      style={{ color: s.color, background: s.bg, border: `1px solid ${s.color}` }}>
      <span aria-hidden="true">{s.icon}</span> {s.label}
    </span>
  )
}
